import { useTranslation } from "next-i18next";
import Image from "next/image";
import Link from "next/link";
import { FC } from "react";
import useUtmParams from "~/hooks/useUtmParams";
import Trans from "~/types/translationKeys";
import styles from "./SignUpWidget.module.scss";

interface SignUpWidgetProps {
  blogId?: string;
}

const SignUpWidget: FC<SignUpWidgetProps> = ({ blogId }) => {
  const utmParams = useUtmParams();
  const { t } = useTranslation();

  return (
    <div className={styles.sign_up_widget} data-aos="fade-down">
      <Image fill src="/images/sign_up_widget_thumbnail.png" alt="thumbnail" />

      <Image
        src="/images/sign_up_email.png"
        alt="email"
        width={55}
        height={66}
        className="absolute bottom-0 right-0"
      />

      <Image
        src="/images/sign_up_website.png"
        alt="email"
        width={71}
        height={60}
        className="absolute left-0 bottom-0 filter blur-[2px]"
      />

      <p className={styles.text}>
        {t(Trans.sign_up_to_create)}
        <br />
        {t(Trans.free_ai_chatbot)}
      </p>

      <Link
        href={{
          pathname: `${process.env.NEXT_PUBLIC_DASHBOARD_URL}/sign-in`,
          query: { ...utmParams },
        }}
        target="_blank"
        className={styles.button}
      >
        {t(Trans.sign_up_now)}
      </Link>
    </div>
  );
};

export default SignUpWidget;
